import React, { lazy, Suspense, useEffect, useState } from 'react';
import { agencyGet } from './agencyApi';

export function useAgencyCapabilities(revision = 0) {
  const [capabilities, setCapabilities] = useState(null);
  useEffect(() => {
    let active = true;
    agencyGet('/capabilities').then(value => { if (active) setCapabilities(value); })
      .catch(() => { if (active) setCapabilities({ enabled: false }); });
    return () => { active = false; };
  }, [revision]);
  return capabilities;
}

const Workspace = lazy(() => import('./AgencyWorkspace'));
export default function AgencyEntry({ onBack, initialTab }) {
  return <Suspense fallback={<p className="p-6" role="status">Cargando agencias…</p>}>
    <Workspace onBack={onBack} initialTab={initialTab} />
  </Suspense>;
}
